import { createApi } from "@reduxjs/toolkit/query/react";
import { ExportableFilesSearchParams, ExportableFilesResponse } from "@shared/interfaces";
import { showProgress } from "@shared/utils";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export const exportableFilesApi = createApi({
  reducerPath: "exportableFilesApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["exportable_files"],
  endpoints: (build) => ({
    getExportableFilesToUpload: build.query<ExportableFilesResponse, ExportableFilesSearchParams>({
      providesTags: ["exportable_files"],
      query: (params) => ({
        url: "exportable-files",
        params,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          showProgress(dispatch, queryFulfilled);
        } catch (error) {
          // If an error happens, you can dispatch an action to reset it manually if you want
          dispatch(exportableFilesApi.util.updateQueryData("getExportableFilesToUpload", _, () => undefined));
        }
      },
    }),
  }),
});

export const { useLazyGetExportableFilesToUploadQuery } = exportableFilesApi;
